import React from 'react'
import Navbar from '../components/Nav'
import Footer from '../components/Footer'
import AboutUs from '../components/AboutUS'

const AboutUss = () => {
  return (
    <div>
        <Navbar/>
        <AboutUs/>
        <Footer/>

    </div>
  )
}

export default AboutUss